module.exports = __webpack_public_path__ + "static/media/an.04af1ccd.svg";